import type { ComponentType } from 'react'

import {
    Activity,
    Brain,
    Carrot,
    Flower,
    Footprints,
    HeartPulse,
    Moon,
    Repeat,
    Salad,
    Scale,
    Sprout,
    Wind,
    Zap
} from 'lucide-react'

type IconType = ComponentType<{ className?: string }>

// Pillars inherit their colour accent from their nav group, so they only need
// an icon here. Keyed by pillar slug.
const PILLAR_ICONS: Record<string, IconType> = {
    sleep: Moon,
    'gut-health': Salad,
    nutrition: Carrot,
    'heart-circulation': Activity,
    'womens-health': Flower,
    'herbal-remedies': Sprout,
    'stress-management': HeartPulse,
    meditation: Brain,
    breathwork: Wind,
    movement: Footprints,
    'energy-and-focus': Zap,
    'work-life-balance': Scale,
    'habits-and-learning': Repeat
}

export const pillarIcon = (slug: string): IconType => PILLAR_ICONS[slug] ?? Sprout

// Subtopic buckets used to group a pillar's cluster articles on its hub page,
// per the internal-linking rules. Order here is the order they render in.
export const CLUSTER_GROUPS = [
    'Foundations',
    'Troubleshooting',
    'Environment & Tools',
    'Special Cases'
] as const

export const CLUSTER_FALLBACK = 'More in this guide'
